import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/nhcxTypes';

export const setPayerDropDownVisible = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_PAYER_DROPDOWN, payload);

export const setMemberName = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_MEMBER_NAME, payload);

export const setTotalAmount = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_TOTAL_AMOUNT, payload);

export const getPolicySearchResults = (payload: any, onSuccess: any, onError: any): Action<any> => {
  return {
    type: actionTypes.GET_POLICY_SEARCH_RESULTS, ...{ payload, onSuccess, onError },
  };
};

export const setPolicySearchResults = (policySearchList: any[]): Action<any[]> => ({
  type: actionTypes.SET_POLICY_SEARCH_RESULTS, ...{ policySearchList },
});

export const getIPODetails = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
  return {
    type: actionTypes.GET_IPO_DETAILS, ...{ payload, onSuccess, onError },
  };
};

export const setIPOId = (ipoCorelationId: any): Action<any> =>
  updateAction(actionTypes.SET_IPO_ID, ipoCorelationId);

export const setCoverageId = (memberCorelationId: any): Action<any> =>
  updateAction(actionTypes.SET_COVERAGE_ID, memberCorelationId);

export const setIPOResponse = (ipoResponse: any): Action<any[]> =>
  updateAction(actionTypes.SET_IPO_RESPONSE, ipoResponse);

export const setCoverageResponse = (coverageResponse: any): Action<any> =>
  updateAction(actionTypes.SET_COVERAGE_RESPONSE, coverageResponse);

export const setSelectedPolicyDetail = (selectedPolicyDetail: any): Action<any> =>
  updateAction(actionTypes.SET_SELECTED_POLICY_DETAIL, selectedPolicyDetail);

export const clearNHCXState = (): Action<void> => ({
  type: actionTypes.CLEAR_NHCX_STATE,
});

export const setNotifyModal = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_NOTIFY_MODAL, payload);

export const getNHCXResponse = (): Action<any[]> => ({
    type: actionTypes.GET_NHCX_RESPONSE,
});

export const setCardChanged = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_CARD_CHANGED, payload);

export const setShowOtpScreen = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_SHOW_OTP_SCREEN, payload);

export const setParticipantCreated = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_PARTICIPATION_CREATED, payload);

export const saveParticipantDetails = (data: any, onSuccess: any = (): any => { }, onError: any = (): any => {},
onNotifyAlreadyExisting: any = (): any => {}): Action<any> =>
  updateAction(actionTypes.SAVE_PARTICIPANT, { data, onSuccess, onError, onNotifyAlreadyExisting });

export const confirmParticipantDetails = (data: any, onSuccess: any = (): any => { }, onError: any = (): any => {}): Action<any> =>
  updateAction(actionTypes.CONFIRM_PARTICIPANT, { data, onSuccess, onError });

export const fetchParticipantDetails = (providerId: any, onSuccess: any = (): any => { }, onError: any = (): any => {}): Action<any> =>
  updateAction(actionTypes.GET_PARTICIPANT_DETAILS, { providerId, onSuccess, onError });

export const fetchFacilityRegistry = (facilityId: any, onSuccess: any = (): any => { }, onError: any = (): any => {}): Action<any> =>
  updateAction(actionTypes.FETCH_FACILITY_REGISTRY, { facilityId, onSuccess, onError });

export const updateCertificates = (participantId: any, onSuccess: any = (): any => { }, onError: any = (): any => {}): Action<any> =>
  updateAction(actionTypes.UPDATE_CERTIFICATES, { participantId, onSuccess, onError });

export const rollOutPayersForNHCX = (payload?: any): Action<any> =>
  updateAction(actionTypes.ROLLOUT_PAYERS_NHCX, payload);

export const setRadioValue = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_RADIO_VALUE, payload);

export const setParticipantAlreadyExisting = (paylaod: any): Action<any> =>
  updateAction(actionTypes.SET_IF_PARTICIPANT_EXISTING, paylaod);
